import tw from "twin.macro";
import { styled } from "~/config/stitches";

const CheckboxLabel = styled("label", {
  ...tw`font-medium text-neutral-700 ml-3`,
});

export { CheckboxLabel };
